// 종목 기준 시세 알림 벨 아이콘 (tb_stock_alert)
// AlertButton(공용 벨+툴팁)을 재사용하고, 데이터 조회/저장 모달만 담당한다.
import React, { useState, useEffect, useCallback } from 'react';
import AlertButton from './AlertButton';
import StockAlertModal from './StockAlertModal';
import { fetchStockAlert } from '../../api/stockAlert';

const fPrice = v => v != null ? `${Number(v).toLocaleString()}원` : '';

const AlertBellStock = ({ ticker, stockName }) => {
  const [alertInfo, setAlertInfo] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const load = useCallback(async () => {
    if (!ticker) return;
    try {
      const data = await fetchStockAlert(ticker);
      setAlertInfo(data);
    } catch {
      setAlertInfo(null);
    }
  }, [ticker]);

  useEffect(() => { load(); }, [load]);

  const hasAlert = !!(alertInfo?.alert_type_id_up || alertInfo?.alert_type_id_down);

  return (
    <>
      <AlertButton
        hasAlert={hasAlert}
        alertEnabled={!!alertInfo?.alert_enabled}
        alertTypeNameUp={alertInfo?.type_name_up}
        alertTypeNameDown={alertInfo?.type_name_down}
        upExtra={fPrice(alertInfo?.alert_up_price)}
        downExtra={fPrice(alertInfo?.alert_down_price)}
        onColor="#FFA500"
        onClick={() => setShowModal(true)}
      />
      {showModal && (
        <StockAlertModal
          ticker={ticker}
          stockName={stockName}
          alertInfo={alertInfo}
          onClose={() => setShowModal(false)}
          onSaved={() => { load(); setShowModal(false); }}
        />
      )}
    </>
  );
};

export default AlertBellStock;
